import React from "react";
import address from "../../assets/images/devdetail/address.svg";
import experience from "../../assets/images/devdetail/experience.svg";
import lang from "../../assets/images/devdetail/language.svg";
import remote from "../../assets/images/devdetail/remote.svg";
import star from "../../assets/images/devdetail/star.png";

const ContactCard = () => {
  return (
    <div className="dev-contact-card">
      <div className="dev-contact-card-top">
        <div>
          <span className="dev-contact-card-price">€75</span>
          <span className="dev-contact-card-hour">/</span>
          <span className="dev-contact-card-hour">Hour</span>
        </div>
        <div>
          <ul className="listtop">
            <li>
              <img
                src={star}
                alt=""
                className="dev-detail-content-top-img"
              ></img>
              <span className="dev-detail-card-top">5.0</span>
            </li>
            <li>
              <span className="dev-detail-card-top">7 reviews</span>
            </li>
          </ul>
        </div>
      </div>
      <div>
        <div className="dev-contact-card-flex">
          <input type="radio" checked />
          <p className="dev-contact-avail">Available in 7 days</p>
        </div>
        <div className="dev-contact-card-flex">
          <img src={address} alt="" />
          <div>
            <p>Tbilisi, Georgia</p>
          </div>
        </div>
        <div className="dev-contact-card-add">
          <span>Can work on daily basis and stay in touch</span>
        </div>
        {/* </div> */}
        <div className="dev-contact-card-flex">
          <img src={experience} alt="" />
          <p>7+ years experience</p>
        </div>
        <div className="dev-contact-card-flex">
          <img src={lang} alt="" />
          <p>English: Fluent</p>
        </div>
        <div className="dev-contact-card-flex">
          <img src={remote} alt="" />
          <p>Remote work</p>
        </div>
        <button className="dev-contact-card-btn">Contact Candidate</button>
        <div className="dev-contact-card-invoice">
          <p>€75 x 30 days</p>
          <p>€5,760</p>
        </div>
        <div className="dev-contact-card-invoice dev-contact-card-margin">
          <p>Website fee</p>
          <p>€100</p>
        </div>
        <div className="dev-contact-card-invoice dev-contact-card_total ">
          <p>Total</p>
          <p>€5,860</p>
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
